<template>
    <transition name="fade" mode="out-in">
        <loader v-if="loading"></loader>
        <div v-else class="container">
            <form class="quotetool__step">
                <h2 class="quotetool__step-heading">
                    {{ labels.stepFourTitle }}
                </h2>
                <div class="quotetool__step-form-container">
                    <transition name="fade">
                        <p class="error" v-if="bankVerification == false">Your bank information is not valid</p>
                    </transition>

                    <p>
                        <strong>{{ period }} Year Source for Business Plan</strong> ending {{ endingDate }} for {{ waterSitesCount }} site(s) with total combined consumption of {{ annualUsage }} m<sup>3</sup> p/year
                    </p>

                    <p><strong>{{ totalCharge | toCurrency(2) }}</strong> estimated annual charge</p>
                                        
                    <hr />
                    <div class="form-group" :class="{ 'form-group--error': $v.paymentType.$error }">
                        <label>{{ labels.stepFourPaymentTypeLabel}}</label>
                        <div>
                            <label class="radio-inline">
                                <input v-model="$v.paymentType.$model" type="radio" name="paymentType" id="paymentTypeDD" value="DD"> {{ labels.stepFourPaymentTypeDDLabel }}
                                <span class="checkmark"></span>
                            </label>
                            <label class="radio-inline">
                                <input v-model="$v.paymentType.$model" type="radio" name="paymentType" id="paymentTypeBACS" value="BACS"> {{ labels.stepFourPaymentTypeBACSLabel }}
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>

                    <div class="error" v-if="!$v.paymentType.required">{{ labels.stepFourPaymentTypeValidationMsg }}</div>

                    <div v-if="bacsVisible">
                        <p>Payment information for BACS</p>

                        <p>
                            Payments: {{ (totalCharge / 2) | toCurrency(2) }} bi-annually
                            Recipient: Pennon Water Services Ltd t/a Source for Business<br />
                            Bank: 10 Gresham Street, London, EC2V 7AE<br />
                            Acc. Number: 00220418<br />
                            Sort: 30-00-00
                        </p>

                        <p>
                            Note that by confirming your purchase you are also confirming intent to send payment to the above details by BACS.
                        </p>
                    </div>

                    <div v-if="ddVisible">
                        <h4>
                            {{ labels.stepFourDirectDebitHeading }}
                        </h4>
                         
                        <div class="form-group" :class="{ 'form-group--error': $v.paymentDate.$error }">
                            <label>{{ labels.stepFourPaymentDateLabel }}</label>
                            <div class="row">
                                <div class="col-xs-12 col-sm-4">
                                    <div class="custom-select">
                                        <select v-model="$v.paymentDate.$model" class="form-control">
                                            <option value="" disabled hidden>{{ labels.stepFourPaymentDatePlaceholder }}</option>
                                            <option value="1">1st</option>
                                            <option value="8">8th</option>
                                            <option value="15">15th</option>
                                            <option value="22">22nd</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="error" v-if="!$v.paymentDate.required">{{ labels.stepFourPaymentDateValidationMsg }}</div>

                        <div class="form-group" :class="{ 'form-group--error': $v.paymentAccountName.$error }">
                            <label>{{ labels.stepFourAccountHolderNameLabel }}</label>
                            <input v-model="$v.paymentAccountName.$model" type="text" class="form-control">
                        </div>
                        <div class="error" v-if="!$v.paymentAccountName.required">{{ labels.stepFourAccountHolderNameValidationMsg }}</div>

                        <div class="form-group" :class="{ 'form-group--error': $v.paymentAccountNumber.$error }">
                            <label>{{ labels.stepFourAccountNumberLabel }}</label>
                            <input v-model="$v.paymentAccountNumber.$model"
                                   maxlength="8"
                                   type="text"
                                   class="form-control"
                                   :placeholder="labels.stepFourAccountNumberPlaceholder">
                        </div>
                        <div class="error"
                             v-if="!$v.paymentAccountNumber.required
                         || !$v.paymentAccountNumber.minLength
                         || !$v.paymentAccountNumber.maxLength
                         || !$v.paymentAccountNumber.isPositive
                         || !$v.paymentAccountNumber.numeric">
                            {{ labels.stepFourAccountNumberValidationMsg }}
                        </div>

                        <div class="form-group"
                             :class="{ 'form-group--error': $v.sortcode1.$error || $v.sortcode2.$error || $v.sortcode3.$error }">
                            <label>{{ labels.stepFourAccountSortLabel }}</label>
                            <div class="row">
                                <div class="col-xs-2 form-control__container--sort-code">
                                    <input v-model="sortcode1"
                                           type="text"
                                           class="form-control"
                                           ref="sortcode1"
                                           maxlength="2"
                                           @keyup="focusSortCode(2)"
                                           :placeholder="labels.stepFourAccountSortFirstPlaceholder">
                                </div>
                                <div class="col-xs-2 form-control__container--sort-code">
                                    <input v-model="sortcode2"
                                           type="text"
                                           class="form-control"
                                           ref="sortcode2"
                                           maxlength="2"
                                           @keyup="focusSortCode(3)"
                                           :placeholder="labels.stepFourAccountSortSecondPlaceholder">
                                </div>
                                <div class="col-xs-2 form-control__container--sort-code">
                                    <input v-model="sortcode3"
                                           type="text"
                                           class="form-control"
                                           ref="sortcode3"
                                           maxlength="2"
                                           :placeholder="labels.stepFourAccountSortThirdPlaceholder">
                                </div>
                            </div>
                        </div>

                        <div class="error"
                             v-if="!$v.sortcode1.required
                         || !$v.sortcode1.numeric
                         || !$v.sortcode1.maxLength
                         || !$v.sortcode1.minLength
                         || !$v.sortcode1.isPositive
                         || !$v.sortcode2.required
                         || !$v.sortcode2.numeric
                         || !$v.sortcode2.maxLength
                         || !$v.sortcode2.minLength
                         || !$v.sortcode2.isPositive
                         || !$v.sortcode3.required
                         || !$v.sortcode3.numeric
                         || !$v.sortcode3.maxLength
                         || !$v.sortcode3.isPositive
                         || !$v.sortcode3.minLength">
                            {{ labels.stepFourAccountSortValidationMsg }}
                        </div>

                        <div claas="quotetool__step-payment-results">
                            <p>
                                <strong>
                                    {{ labels.stepFourPaymentNote }}
                                </strong>
                            </p> 
                            <p>
                                Direct Debit payment:<br />
                                Payments: {{ (totalCharge / paymentTermNumber) | toCurrency(2) }} x{{ paymentTermNumber }}<br />
                                Recipient: Pennon Water Services Ltd t/a Source for Business<br />
                                Bank: 10 Gresham Street, London, EC2V 7AE<br />
                                Acc. Number: 00220418<br />
                                Sort: 30-00-00
                            </p>
                        </div>

                        <div class="row quotetool__step-direct-debit">
                            <div class="col-xs-8">
                                <h4>{{ labels.stepFourDirectDebitGuaranteeHeading }}</h4>
                            </div>
                            <div class="col-xs-4">
                                <img src="/dist/img/direct-debit-logo.png" title="Direct Debit - Logo" alt="Direct Debit - Logo" class="pull-right img-responsive direct-debit-logo" />
                            </div>
                            <div class="col-xs-12">
                                <ul>
                                    <li>The Guarantee is offered by all banks and building societies that accept instructions to pay Direct Debits</li>
                                    <li>If there are any changes to the amount, date or frequency of your Direct Debit Source for Business will notify you (normally 10 working days) in advance of your account being debited or as otherwise agreed. If you request Source for Business to collect a payment, confirmation of the amount and date will be given to you at the time of the request</li>
                                    <li>If an error is made in the payment of your Direct Debit, by Source for Business or your bank or building society, you are entitled to a full and immediate refund of the amount paid from your bank or building society</li>
                                    <li>If you receive a refund you are not entitled to, you must pay it back when Source for Business asks you to</li>
                                    <li>You can cancel a Direct Debit at any time by simply contacting your bank or building society. Written confirmation may be required. Please also notify Source for Business.</li>
                                </ul>
                            </div>
                        </div>
                        <hr />
                    </div>

                    <div class="form-group" :class="{ 'form-group--error': $v.waterPaymentVAT.$error }">
                        <label>{{ labels.stepFourVATLabel }}</label>
                        <div>
                            <label class="radio-inline">
                                <input v-model="$v.waterPaymentVAT.$model" type="radio" name="waterPaymentVAT" id="waterPaymentVATYes" :value="true"> {{ labels.stepFourVATYesLabel }}
                                <span class="checkmark"></span>
                            </label>
                            <label class="radio-inline">
                                <input v-model="$v.waterPaymentVAT.$model" type="radio" name="waterPaymentVAT" id="waterPaymentVATNo" :value="false"> {{ labels.stepFourVATNoLabel }}
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>

                    <div class="error" v-if="!$v.waterPaymentVAT.required">{{ labels.stepFourVATValidationMsg }}</div>


                    <div class="form-group" :class="{ 'form-group--error': $v.termsAcceptance.$error }">
                        <div class="checkbox">
                            <label>
                                <input v-model="$v.termsAcceptance.$model" type="checkbox" :value="true">
                                <span v-html="labels.stepFourTermsConditionsLabel"></span>
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>

                    <div class="error" v-if="!$v.termsAcceptance.required || !$v.termsAcceptance.isTrue">
                        {{ labels.stepFourTermsConditionsValidationMsg }}
                    </div>

                    <!-- TODO: DOCUSIGN INTEGRATION ONCE ITS PLANNED -->
                    <div class="error" v-if="true">{{ labels.stepFourDocusignValidationMsg }}</div>

                    <div>
                        <p>
                            {{ labels.stepFourContractNote }}
                        </p>
                    </div>

                    <div class="form-group" :class="{ 'form-group--error': $v.receiveInformation.$error }">
                        <label>{{ labels.stepFourAdditionalInfoLabel }}</label>
                        <div>
                            <label class="radio-inline">
                                <input v-model="$v.receiveInformation.$model" type="radio" name="receiveInformation" id="receiveInformationYes" :value="true"> {{ labels.stepFourAdditionalInfoYesLabel }}
                                <span class="checkmark"></span>
                            </label>
                            <label class="radio-inline">
                                <input v-model="$v.receiveInformation.$model" type="radio" name="receiveInformation" id="receiveInformationNo" :value="false"> {{ labels.stepFourAdditionalInfoNoLabel }}
                                <span class="checkmark"></span>
                            </label>
                        </div>
                    </div>

                    <div class="error" v-if="!$v.receiveInformation.required">
                        {{ labels.stepFourAdditionalInfoValidationMsg }}
                    </div>

                    <p v-if="receiveInformation == false">              
                        {{ labels.stepFourDeclinedAdditionalInfoMsg }}
                    </p>

                    <div v-if="receiveInformation == true">
                        <div class="form-group" :class="{ 'form-group--error': $v.receiveInformationType.$error }">
                            <label>{{ labels.stepFourCommunicationPreferenceLabel }}</label>
                            <div class="checkbox">
                                <label>
                                    <input v-model="$v.receiveInformationType.$model" type="checkbox" value="email">
                                    {{ labels.stepFourCommunicationEmail }}
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="checkbox">
                                <label>
                                    <input v-model="$v.receiveInformationType.$model" type="checkbox" value="post">
                                    {{ labels.stepFourCommunicationPost }}
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div class="checkbox">
                                <label>
                                    <input v-model="$v.receiveInformationType.$model" type="checkbox" value="phone">
                                    {{ labels.stepFourCommunicationPhone }}
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        </div>

                        <div class="error" v-if="!$v.receiveInformationType.required">
                            Please specify your preferred communication methods
                        </div>
                    </div>

                    <button class="btn--chevron" @click.prevent="submit">{{ labels.stepFourConfirmPaymentButton }}</button>


                </div>
            </form>
        </div>
    </transition>
</template>

<script>
    import moment from 'moment';
    import { createHelpers } from 'vuex-map-fields';
    import { required, maxLength, minLength, numeric, between } from 'vuelidate/lib/validators';

    import Loader from '../Loader.vue';

    import { mapState, mapActions } from 'vuex';

    import StepNavigation from '../StepNavigation.vue';

    const { mapFields } = createHelpers({
        getterType: 'paymentStep/getField',
        mutationType: 'paymentStep/updateField',
    });

    export default {
        components: {
            StepNavigation,
            Loader
        },

        data() {
            return {
                bankVerification: null,
                loading: false,
            }
        },

        computed: {
            ...mapFields([
                'estimatedAnnualCharge',
                'paymentType',
                'waterPaymentVAT', 
                'paymentAuthorisation',
                'termsAcceptance',
                'receiveInformation',
                'receiveInformationType',
                'paymentTerm',
                'paymentDate',
                'paymentAccountName',
                'paymentAccountNumber',
                'sortcode1',
                'sortcode2',
                'sortcode3',
            ]),

            ...mapState('microcopy', [
                'labels',
            ]),

            ...mapState('quoteStep', [
                'annualUsage',
                'period',
                'totalCharge',
            ]),

            ...mapState('waterConsumptionStep', [
                'waterSitesCount',
            ]),

            endingDate() {
                return moment().add(+this.period, 'years').format('DD/MM/YY');
            },

            bacsVisible() {
                return this.paymentType === 'BACS' ? true : false;
            },

            ddVisible() {
                return this.paymentType === 'DD' ? true : false;
            },

            paymentTermNumber() {
                return this.paymentTerm == 'quarterly' ? 4 : 12;
            }
        },

        methods: {
            ...mapActions('paymentStep', {
                getBankVerification: 'getBankVerification',
                fetchSigningUrl: 'fetchSigningUrl',
            }),

            focusSortCode(sortCodeNumber) { 
                const currentTypedSortcode = this[`sortcode${sortCodeNumber - 1}`];
                if (currentTypedSortcode !== null && currentTypedSortcode.length == 2) {
                    this.$refs[`sortcode${sortCodeNumber}`].focus();
                }
            },       

            submit() {
                this.$v.$touch();

                if (!this.$v.$invalid) {
                    
                    this.loading = true;
                    if (this.paymentType == 'DD') {
                        this.getBankVerification().then(response => {
                            if (response) {
                                this.bankVerification = true;

                                this.fetchSigningUrl().then(response => {
                                    location.href = response;
                                }).catch(error => {
                                    console.error(error);
                                    this.loading = false;
                                })
                            } else {
                                this.loading = false;

                                this.bankVerification = false;
                            }
                        }).catch(error => {
                            console.error(error);
                            this.loading = false;
                        });
                    } else {
                        this.fetchSigningUrl().then(response => {
                            location.href = response;
                            }).catch(error => {
                                console.error(error); 
                                this.loading = false;
                            }); 
                    }
                }
            },  

            
        },

        validations() {
            let rules = {
                paymentType: {
                    required,
                },
                waterPaymentVAT: {
                    required,
                },
                termsAcceptance: {
                    required,
                    isTrue: function (value) {
                        return value == true;
                    }
                },
                receiveInformation: {
                    required,
                }
            };

            if (this.receiveInformation == true) {
                rules.receiveInformationType = {
                    required,
                }
            }

            if (this.paymentType == 'DD') {
                rules.paymentDate = {
                    required,
                } 
                rules.paymentAccountName = {
                    required,
                }
                rules.paymentAccountNumber = {
                    required,   
                    numeric,  
                    minLength: minLength(8),
                    maxLength: maxLength(8),
                    isPositive: function (value) {
                        return value > 0;
                    }
                } 
                rules.sortcode1 = {
                    required, 
                    numeric,
                    maxLength: maxLength(2),
                    minLength: minLength(2),
                    isPositive: function (value) {
                        return value >= 0;
                    }
                }
                rules.sortcode2 = {
                    required,
                    numeric,
                    maxLength: maxLength(2),
                    minLength: minLength(2),
                    isPositive: function (value) {
                        return value >= 0;
                    }
                }
                rules.sortcode3 = {
                    required,
                    numeric,
                    maxLength: maxLength(2),
                    minLength: minLength(2), 
                    isPositive: function (value) {
                        return value >= 0;
                    }
                }
            } 

            return rules;
        }
    }
</script>